import { AbstractControl } from '@angular/forms';

export function BudgetMottagareNotFinansiar(bidragsMottagareSet: Set<string>) {
  return (control: AbstractControl) => {
    if (control.value) {
      const parsedValue = JSON.parse(control.value);

      // Leta i listan av bidragsmottagare efter finansiärer, det är inte tillåtet att vara både och
      const invalidFinanciers = parsedValue.filter((financier) =>
        bidragsMottagareSet.has(financier.rowId),
      );
      if (invalidFinanciers.length > 0) {
        return {
          [`BudgetMottagareNotFinansiar_${invalidFinanciers[0].rowId}`]: true,
        };
      }
    }
  };
}
